export default {"src":"/_next/static/media/tag-favourite.39ead74c.svg","height":20,"width":26,"blurWidth":0,"blurHeight":0};